import baseUrl from "./baseUrl"
import axios from "axios";
import Vue from 'vue'
import { Toast } from "vant";
import appConfig from "./appConfig"
import store from '@/store'
import { encryptPublicLong, decryptPrivateLong } from '../lib/encryption/index'
import CryptoJS from 'crypto-js'

axios.defaults.timeout = 30000;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.put["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.get["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.version = appConfig.version

axios.interceptors.request.use(
  async config => {
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    getDecryptData(response)
    return response;
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 402:
            store.dispatch('getSecure')
            error.message = "服务器繁忙请重试(code:000001)";
            break;
        case 403:
          error.message = "操作太频繁，请稍后重试";
          break;
        case 404:
          error.message = "请求错误,未找到该资源"+error.response.config.url;
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器端出错";
          break;
        case 501:
          error.message = "网络未实现";
          break;
        case 502:
          error.message = "网络错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网络超时";
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      error.message = "网络出现问题,请稍后再试";
    }
    if(error.message == "网络出现问题,请稍后再试"){
      return Promise.reject(error);
    } else{
      Toast({
        message: error.message,
        position: "middle",
        forbidClick: true,
        duration: 2000
      });
      return Promise.reject(error);
    }
  }
);

// 公用请求
async function commonAjax(methodType,url, param = {}, toastErr){

  const config = await getEncryptionData({url, data: param});

  return new Promise((resolve, reject) => {
    axios.defaults.headers.userId = store.state.userId || param.userId || ''
    axios.defaults.headers.authorization = store.state.token || param.token || ''
    axios.defaults.headers.token = store.state.token || param.token || ''
    axios.defaults.headers.appVersion = store.state.appVersion || '4.35.10'

    // 兼容某些页面宿主环境在教练端的情况
    if (store.state.teacherToken) {
      axios.defaults.headers.authorization = store.state.teacherToken
      axios.defaults.headers.token = store.state.teacherToken
    }
    if(param.authorization) {
      axios.defaults.headers.authorization = param.authorization;
    }
    if(param.venueId) {
      axios.defaults.headers.venueId = param.venueId;
    }
    axios({
      // headers: {
      //   "version": 1,
      //   "Content-Type": "application/json;charset=utf-8",
      // },
      method: methodType,
      url: url.indexOf('http') > -1 ? url : `${Vue.prototype.baseURLApp}${url}`,
      data: config.data
    }).then(res => {
      switch(""+res.data.code){
        case "1":
        case "200":
          // 成功返回
          resolve(res.data);
          break;
        case "2":
        case 2:
        case 1010002:
        case '1010002':
        case 10100024:
        case '10100024':
          // token 失效，回到登录页面
          // loginOut();
          // 20230523修改 未登入弹窗
          Toast.clear()
          store.commit('openLoginPopup', true)
          reject(res.data);
          break;
        default:
          // 系统级错误，直接提示错误
          if(res.data.msg && toastErr){
            Toast({
              message: res.data.msg,
              forbidClick: true,
              position: "middle",
              duration: 2000
            });
          }
          reject(res.data);
          break;
      }
    }).catch(error => {
      reject(error);
    });
  });
}

export default {
  //get请求
  get(url = baseUrl.baseURLApp, param) {
    return commonAjax('get', url, param)
  },
  //post请求 toastErr 是否toast错误提示 默认展示
  post(url = baseUrl.baseURLApp, param, toastErr = true) {
    return commonAjax('post', url, param, toastErr)
  }
};

function getEncryptionData(config) {//加密
  return new Promise((resolve, reject) => {
    const key = config.url.split('com.cn')[1]

    const way = store.state.secureObj.jsonEncryption[key]
    if (way) { // 需要加密
      // if (way == 1) { // base64
      //   const baseData = jiaBase64(config.data);
      //   config.data = {
      //     data: baseData
      //   }
      // }
      // if (way == 2) { // base64
      //   const baseData = jiaBase64(config.data);
      //   const str = 'appid=' + appid + '&appsecret=VAvhCTEtMZuYBGFgCCgvLorQeQVwG9cy&data=' + baseData;
      //   config.data = {
      //     data: baseData,
      //     sign: CryptoJS.MD5(str).toString()
      //   }
      // }
      if (way == 3) { // rsa
        const RSA = encryptPublicLong(JSON.stringify(config.data), store.state.secureObj.servicePublicKey)
        const str = 'appid=' + store.state.secureObj.appid + '&appsecret=ODU2ODM4NjYwODQ1MjA3NTUyQ0hBT0xV&data=' + RSA;
        config.data = {
          data: RSA,
          sign: CryptoJS.MD5(str).toString()
        }
      }
    }
    resolve(config);
  })
}
function getDecryptData(res) {// 解密
  const way = res.config.headers.secure
  const data = res.data.data;
  if ([1, 2].includes(way)) {//base64
    res.data = JSON.parse(jieBase64(data));
  }
  if (way == 3) { // 解密
    // let decrypt = new Encrypt() // 新建JSEncrypt对象
    let privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAK1WDmJWLZZrsZHctTKEn0A0XNoDOnO/BL07hnMKdRACKZ7XLao19aXNslIi1Lvcv9vjI9H7du4pPXpv4q8SMuoymWBDX+TCBhR84BYMt2c6Fv28eBr7ew+8Bct0+XfQfLj5XcJD/gqbOXdEeIrFWQN++lGjwS5cAPzV7CZeA4nvAgMBAAECgYA1YDubsnflSxJqHTG69bXoWneBNt9IBzlZYDwdrsmvfUr9u7s3H9ieDwJrYohptSdreb1tCudrnU1uJ4gBazQ8Ak5PxkM0tTiYLBL8P7FGmgNBh3JoXm+AfULokzNkGWCnBgpYW1Ty2KYsGurBOgSmUReybzsNe/v+xjnTyOKnMQJBANObFmUdyZFzt7sgAzbxhlEMxOgJzb2pYsChDaorO+g71yTSok+Ro6qvzloTnVU69G1WUmiNO3fY0HpwzNow9akCQQDRs5WarzZEaFTOsysrWnThJst8tqkSVfh5gTWDg+Ua+NZ7G64o8vBmyfbW8xn0BQoWPsMuMcVDGXyjoKtdDRHXAkAmL9+7wcNlh1+J2n4aBT47FDXYtiQ17QKQRsBDjGfUQjBSSdzWxS6nF/ECWnXTMr93l9NpYMtxlmQRJJgjbCB5AkBLa86r4sae1fNioFgvcIpHDF/1i/DFMnx6nvkzQvXcvJDPmEYMXkwOfCc2ahr0g/d7xrkGXUo4dus4IqpffjrjAkEAq/jRk4+KuTCgiRzUO+15d6ihAdb8QTI4Bx6Er5UzM5hcnFx1/ZCAkTbNpGKrZH1N64aKgLVqMM3TDsQD6h+Fvw=='

    res.data = JSON.parse(decryptPrivateLong(data, privateKey))
  }
}


